<template>
  <div id="app">
    <MetaPixel v-if="pixelId" :pixel-id="pixelId" />
    <XPixel v-if="xAdsId" :x-pixel-id="xAdsId" />
    <GoogleAds v-if="googleAdsId" ref="googleAdsRef" :conversion-id="googleAdsId" />
    <!-- <GoogleAds v-if="googleAdsId" ref="googleAdsRef" :conversion-id="googleAdsId" :conversion-label="googleAdsLabel" /> -->

     <!-- Consent Banner -->
    <ConsentBanner v-if="hasAnyTracking" @consent-given="handleConsentGiven" :privacy-policy-url="(privacyPolicyUrl as string)" />

    <router-view />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, computed } from 'vue';
import MetaPixel from './utils/MetaPixel.vue';
import XPixel from './utils/XPixel.vue';
import GoogleAds from './utils/GoogleAds.vue';
import ConsentBanner from './views/ConsentBanner.vue'
import { useRoute } from 'vue-router';

interface ConsentChoice {
  action: 'accept' | 'decline';
  timestamp: string;
}

const route = useRoute();
const pixelId = ref<string | null>(null);
const xAdsId = ref(null);
const googleAdsId = ref(null);
const googleAdsLabel = ref(null);
const googleAdsRef = ref(null);

const privacyPolicyUrl = ref<string | null>(null);

const hasAnyTracking = computed(() => {
  return !!(pixelId.value || xAdsId.value || googleAdsId.value);
});

const handleConsentGiven = (choice: ConsentChoice) => {
  // Notify all tracking components about consent change
  window.postMessage(JSON.stringify({
    type: 'CONSENT_UPDATED',
    payload: choice
  }), '*');
};


watch(
  () => route.params.productId,
  async (newProductId) => {
    if (newProductId) {
      const newCompanyId = route.params.companyId;  
      const response = await fetch(process.env.VUE_APP_API_URL + `/companies/${newCompanyId}/products/${newProductId}?view=content`);
      const data = await response.json();
      // privacyPolicyUrl.value = "https://getre.al/privacy-policy";
      if(data.isMetaPixel) {
        pixelId.value = data.metaPixelId;
      }
      if(data.isXPixel) {
        xAdsId.value = data.xPixelId;
      }
      if(data.isGoogleAds) {
        googleAdsId.value = data.googleAdsId;
      }
       if(data.privacyLink) {
        privacyPolicyUrl.value = data.privacyLink;
      }
    }
  }
);

// router.beforeEach((to) => {
//   if (to.path === "/") {
//     window.location.replace("http://getre.al");
//   }
// });
</script>
